export default import.meta.ROLLUP_FILE_URL_MrY$qGVVz7YF_b_UYH2ITQ